import React from 'react'

const Manual_solicitar_delivery_uber_direct_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          ¿Cómo solicitar delivery de Uber Direct? (orden de ecommerce)
        </h2>
        <iframe
          src="https://scribehow.com/embed/Como_solicitar_delivery_de_Uber_direct_orden_de_ecommerce__Xv9p6IqmQbGkToluh-maGw?as=scrollable"
          className="scribe-iframe-general-74"
          width="100%"
          height="6000"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_solicitar_delivery_uber_direct_ecommerce
